import { render } from "./arquivos.vue?vue&type=template&id=2f404a1c"
import script from "./arquivos.vue?vue&type=script&lang=js"
export * from "./arquivos.vue?vue&type=script&lang=js"
script.render = render

export default script